'use strict'
import * as PIXI from 'pixi.js'
import ViewBase from '../../../view-base.view'
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import CanvasModel from "../../../../models/custom-vision/custom-vision.canvas.model";

export default function CVIterationImageDetailView() {
    ViewBase.call(this);

    let selectedProjectId = 0;
    let selectedIterationId = 0;
    let selectedImageId = 0;

    let app = new PIXI.Application({
        width: 700,
        height: 500,
        backgroundColor: 0xffffff
    });

    let onSelectionBoxConfirmed = () => { }

    let canvasModel = new CanvasModel(app, onSelectionBoxConfirmed, true);

    let canvas = null;

    let imagePreview = null;

    let onPopupClose = (e) => { };

    let _cancel = (e) => {
        onPopupClose(e);
    }

    let _loadImage = (page) => {
        trainModel.getIterationImage(
            (result) => {                
                imagePreview = result.fileContent;

                m.redraw();

                var image = new Image();

                image.onload = function() {      
                    let imageWidth = this.naturalWidth;
                    let imageHeight = this.naturalHeight;

                    
                    canvasModel.clearAllChildren();

                    canvasModel.setupSceneImage(this.src, imageWidth, imageHeight);

                    canvasModel.drawGrid();

                    for(var i = 0; i < result.tags.length; i++) {
                        let currentTag = result.tags[i];
    
                        canvasModel.renderSelectionBoxForExistingTag(currentTag);
                    }
                    
                    m.redraw();
                }

                // Load image.
                image.src = imagePreview;
            }, (error) => {
                this.handleError(error);
            },
            selectedProjectId,
            selectedIterationId,
            selectedImageId);
    }

    return {
        oninit: (vnode) => {

            if (vnode.attrs.onPopupClose) {
                onPopupClose = vnode.attrs.onPopupClose;
            }
            if (vnode.attrs.onSaveComplete) {
                onSaveComplete = vnode.attrs.onSaveComplete;
            }
            if (vnode.attrs.onDeactivateComplete) {
                onDeactivateComplete = vnode.attrs.onDeactivateComplete;
            }
            if(vnode.attrs.projectId && vnode.attrs.iterationId && vnode.attrs.imageId) {
                selectedProjectId = vnode.attrs.projectId;
                selectedIterationId = vnode.attrs.iterationId;
                selectedImageId = vnode.attrs.imageId;

                _loadImage();
            }
        },
        onremove: (vnode) => {
            app.destroy();
        },
        view: ({ attrs }) => {
            if (canvas == null && document.getElementsByTagName("canvas").length > 0) {
                canvas = document.getElementsByTagName("canvas")[0];

                canvas.addEventListener('contextmenu', function (e) {
                    e.preventDefault();
    
                    if(e.which === 3) {
                        canvasModel.resetSelectionBox();
                        
                        m.redraw();
                    }
                });
            }
            

            return [
                m('.row',
                    m('col-md-12', 
                        m('.card',
                            m('.card-body',
                                m('form.my-form',
                                    m('.row.col-md-12',
                                        m('.col-md-9.mt-4', 
                                            m("img[id='mainImage']", { "src": imagePreview, "style": "max-width: 100%; display: none;" }),
                                            m('.pixiContainer', {
                                                oncreate: ({ dom }) => dom.appendChild(app.view)
                                            })
                                        ),
                                    ),
                                )
                            ),
                            m('.card-footer',
                                m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                                    m("button.btn.btn-white[type='button']", { onclick: _cancel }, this.getText("LT00000021", "Close"))
                                )
                            )
                        )
                    ),
                ),
                this.getBaseViews()
            ];
        },
    };
}
